import { Action } from '@ngrx/store';

import { SchoolSearchCriteria } from '../../../scp/search/models/school-search-criteria.model';

export enum ReportsSchoolSearchActionTypes {
  ExecuteReportSearch = '[SchoolReportSearch] Execute Report Search',
}

export class ExecuteReportsSchoolSearch implements Action {
  readonly type = ReportsSchoolSearchActionTypes.ExecuteReportSearch;
  constructor(public payload: SchoolSearchCriteria) { }
}

export type ReportsSchoolSearchActions =
  | ExecuteReportsSchoolSearch;
